/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { SortDirection, TableColumn } from '../Types';
import { ChevronDown, ChevronUp } from '../../../Icons';
import styles from './table-header.module.css';

interface TableHeaderProps {
    columns: TableColumn[];
    initialSortColumn: string;
    initialSortDirection: SortDirection;
    sortColumnCallback?: (columnOperator: string) => void;
    sortDirectionCallback?: (sortDirection: SortDirection) => void;
    disableSort?: boolean;
}

// eslint-disable-next-line import/prefer-default-export
export const TableHeader: React.FC<TableHeaderProps> = ({
    columns,
    initialSortColumn,
    initialSortDirection,
    sortColumnCallback,
    sortDirectionCallback,
    disableSort = false,
}) => {
    const namespaces = columns
        .map((column) => (column.i18nKey?.includes(':') ? column.i18nKey?.split(':')[0] : undefined))
        .filter(Boolean);
    const { t } = useTranslation(namespaces);
    const [sortColumn, setSortColumn] = React.useState<string>(initialSortColumn);
    const [sortDirection, setSortDirection] = React.useState<SortDirection>(initialSortDirection);

    React.useEffect(() => {
        if (sortColumnCallback) {
            sortColumnCallback(sortColumn);
        }
    }, [sortColumn]);

    React.useEffect(() => {
        if (sortDirectionCallback) {
            sortDirectionCallback(sortDirection);
        }
    }, [sortDirection]);

    const toggleSortDirection = () => {
        // eslint-disable-next-line no-unused-expressions
        sortDirection === SortDirection.ASC ? setSortDirection(SortDirection.DESC) : setSortDirection(SortDirection.ASC);
    };

    const handleSort = (operator: any) => {
        if (operator.includes('custom')) return;

        // eslint-disable-next-line no-unused-expressions
        sortColumn === operator ? toggleSortDirection() : setSortColumn(operator);
    };

    return (
        <div className={styles.TableHeader}>
            {columns.map(({ display, i18nKey, operator, width, flex, disableSort: disableColumnSort }) => (
                <div
                    className={classNames(styles.ColumnHeader, {
                        [styles.ColumnHeaderDisabled]: disableSort || disableColumnSort,
                    })}
                    onClick={() => !disableSort && !disableColumnSort && handleSort(operator)}
                    key={`table-header-${operator}`}
                    style={flex ? { width, flex } : { width }}
                >
                    <p className={styles.TableHeaderText} data-qa={`table-header-${i18nKey || display}`}>
                        {i18nKey ? t(i18nKey) : display}
                    </p>
                    {sortColumn === operator && !disableSort && !disableColumnSort ? (
                        sortDirection === SortDirection.ASC ? (
                            <ChevronUp />
                        ) : (
                            <ChevronDown />
                        )
                    ) : null}
                </div>
            ))}
        </div>
    );
};
